<template lang="html">

  <article class="noticia-el animation">
    <div class="contenedor-imagen">

      <img v-if="!!image" :src="image" :alt="data.titulo">
      <div class="contenedor-categorias row-start" :withoutImage="!!!image">
        <router-link :class="[!!!image ? '-red' : '', 'categoria-el']" :to="'/'+$i18n.locale+'/'+$t('enlaces.noticias')+'/'+data.categoria.slug"> {{$t('noticias.'+data.categoria.slug+'')}}</router-link>
        
      </div>
    </div>
    <div class="contenedor-texto">
      <h2 class="titulo-noticia">{{data.titulo}}</h2>
      <h3 class="fecha-texto">{{data.fecha.day}} {{$t(`meses[${Number(data.fecha.month)-1}]`)}} {{data.fecha.year}}</h3>
      <p class="entradilla" v-html="data.entradilla"></p>
    </div>
    <router-link  :to="'/'+$i18n.locale+'/'+$t('enlaces.noticia')+'/'+data.slug" class="enlace-cover"></router-link>
  </article>

</template>

<script lang="js">

  import {mapGetters} from 'vuex';

  export default  {
    name: 'noticia',
    props: ['data'],
    mounted() {

    },
    data() {
      return {
          
      }
    },
    methods: {

    },
    computed: {
      ...mapGetters({
        lang : 'getLanguage',
        server : 'getServer'
      }),
      image(){
        if(this.data.list_img && this.data.list_img.enlace){
          return this.data.list_img.enlace;
        }
        if(this.data.img && this.data.img.enlace){
          return this.data.img.enlace;
        }
        return false;
      }
    }
  }
</script>

<style scoped lang="scss">

  @import '@/assets/css/colors.scss';

  .noticia-el {
    width: 49%;
    margin-bottom: 20px;
    display: inline-block;
    position: relative;
    background: white;
    cursor: pointer;
    z-index: 5;
  }

  .otras-noticias .noticia-container .noticia-el{
    width: 100%;
  }

  .contenedor-imagen{
    width: 100%;
    position: relative;
    overflow: hidden;
    min-height: 60px;
    background: white;
    cursor: pointer;
    .contenedor-categorias{
      position: absolute;
      left: 0;
      bottom: 20px;
      padding:0 20px;
      width: 100%;
      &[withoutImage=true]{
        bottom:0;
      }
    }
    img{
      max-width: 100%;
      display: block;
    }
  }
  
  .contenedor-texto{
    padding: 20px;
    background: white;
    text-align: left;
  }


  .entradilla{
    line-height: 20px;
  }

  .fecha-texto{
    text-transform: uppercase;
    color: $cranberry;
    width: 100%;
    margin-bottom: 10px;
    font-family: 'Futura LT CondensedExtraBold';
    font-size: 16px;
  }

  .modulo-noticias .noticia-el{
    width: calc(33.3333333% - 10px);

    .entradilla{
      max-height: 10em;
      overflow: hidden;
    }

  }

  .otras-noticias .noticia-el{
    .entradilla{
      max-height: 10em;
      overflow: hidden;
    }
  }

  @media screen and (max-width: 1023px){
    .modulo-noticias .noticia-el{
      width: calc(50% - 10px);

    }

  }

    @media screen and (max-width: 666px){
    .modulo-noticias .noticia-el,
    .noticia-el{
      width: 100%;
    }

  }


</style>



// WEBPACK FOOTER //
// src/components/parts/noticia-el.vue